import 'ol/ol.css'
import * as control from 'ol/control'
import { Map, View } from 'ol/index'
import { Tile as TileLayer } from 'ol/layer'
import { XYZ } from 'ol/source'
function initMap() {
    const map = new Map({
        target: 'eguid-map',
        controls: control.defaults({ attribution: false, zoom: true, rotate: true }),
        view: new View({
          center: [119,32],
          maxZoom: 21,
          zoom: 8,
          minZoom: 7,
          projection: 'EPSG:4326',
        })
      });
      //添加高德地图图层
    const gaodeLayer=new TileLayer({
            source: new XYZ({
              url: 'http://wprd0{1-4}.is.autonavi.com/appmaptile?lang=zh_cn&size=1&style=7&x={x}&y={y}&z={z}',
            }),
            projection: 'EPSG:3857'
          });
          map.addLayer(gaodeLayer);
}
export {initMap}